import React from "react";

const Hero = ({ heroTitle, showHeroTitle = true }) => {
  return (
    <section className="hero">
      <style>
        {`
          @media (min-width: 1025px) and (max-width: 1280px) {
            .hero {
              min-height: 100vh;
            }

            .hero-video {
              object-fit: cover;
              object-position: center center;
            }

            .hero-text {
              padding: 0 clamp(28px, 4vw, 48px) 118px;
            }

            .hero-text h1 {
              font-size: clamp(3rem, 4.4vw, 4.6rem);
            }

            .exp {
              left: 50%;
              bottom: 30px;
            }
          }

          @media (min-width: 1281px) {
            .hero {
              min-height: 100vh;
            }

            .hero-video {
              object-fit: cover;
              object-position: center center;
            }

            .hero-text {
              padding: 0 clamp(36px, 5vw, 72px) 128px;
            }

            .hero-text h1 {
              font-size: clamp(3.4rem, 4.8vw, 6.2rem);
            }

            .exp {
              left: 50%;
              bottom: 34px;
            }
          }

          .hero {
            position: relative;
            height: 100vh;
            height: 100svh;
            min-height: 100vh;
            min-height: 100svh;
            width: 100%;
            overflow: hidden;
          }

          .hero-video {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: -2;
          }

          .hero-overlay {
            position: absolute;
            inset: 0;
            background: rgba(0, 0, 0, 0.4);
            z-index: -1;
          }

          .hero-text {
            position: relative;
            z-index: 2;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            min-height: 100%;
            text-align: center;
          }

          .hero-text h1 {
            color: white;
            font-weight: 700;
            line-height: 1.1;
            margin: 0;
          }

          .exp {
            position: absolute;
            transform: translateX(-50%);
            text-align: center;
            z-index: 2;
          }

          .scroll {
            color: white;
            margin-top: 10px;
            font-size: 14px;
          }

          .scroll-down {
            display: inline-flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-decoration: none;
          }

          .scroll-arrow-stack {
            display: flex;
            flex-direction: column;
            gap: 6px;
          }

          .scroll-arrow-symbol {
            width: 14px;
            height: 14px;
            border-right: 2px solid white;
            border-bottom: 2px solid white;
            transform: rotate(45deg);
            animation: bounce 1.5s infinite;
          }

          .scroll-arrow-symbol:nth-child(2) {
            animation-delay: 0.2s;
          }

          @keyframes bounce {
            0%,
            100% {
              transform: rotate(45deg) translate(0, 0);
              opacity: 0.7;
            }

            50% {
              transform: rotate(45deg) translate(6px, 6px);
              opacity: 1;
            }
          }

          @media (max-width: 1024px) {
            .hero {
              height: 100vh;
              height: 100svh;
              min-height: 100vh;
              min-height: 100svh;
            }

            .hero-video {
              object-fit: cover;
              object-position: center center;
            }

            .hero-text {
              padding: 0 20px 110px;
            }

            .exp {
              left: 50%;
              bottom: 22px;
            }
          }
        `}
      </style>

      <video
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        className="hero-video"
      >
        <source
          src="https://blackroth-images.s3.ap-south-1.amazonaws.com/output-ios.mp4"
          type="video/mp4"
        />

        Your browser does not support the video tag.
      </video>

      <div className="hero-overlay"></div>

      <div className="hero-text">
        {showHeroTitle && <h1 id="hero-title">{heroTitle}</h1>}
      </div>

      <div className="exp">
        <a
          href="#services"
          className="scroll-down"
          aria-label="Scroll to Explore"
        >
          <span className="scroll-arrow-stack" aria-hidden="true">
            <span className="scroll-arrow-symbol"></span>
            <span className="scroll-arrow-symbol"></span>
          </span>
        </a>

        <p className="scroll">Scroll to Explore</p>
      </div>
    </section>
  );
};

export default Hero;
 
